'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdToys = function MdToys(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 20c0 5-4.1 9.1-9.1 9.1s-9.3-4.1-9.3-9.1h18.4z m0 0c-5 0-9.1-4.1-9.1-9.1s4.1-9.3 9.1-9.3v18.4z m0 0c5 0 9.1 4.1 9.1 9.1s-4.1 9.3-9.1 9.3v-18.4z m0 0c0-5 4.1-9.1 9.1-9.1s9.3 4.1 9.3 9.1h-18.4z' })
        )
    );
};

exports.default = MdToys;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/toys.js
// module id = 1285
// module chunks = 0